/**
 * @fileoverview Copy from HeaderScriptProvider in phase2
 */

import { useScript } from "@sphtech/web2-core/hooks";

import dfpPreview from "./dfpPreview";
import { facebookEventScript, facebookNoScript } from "./facebook";
import useLink from "./hooks/useLink";
import useScriptFunction from "./hooks/useScriptFunction";
import hotjarTrackingCode from "./hotjarTrackingCode";
import {
  linkedinPixelCode_noScript,
  linkedinPixelCode_script,
} from "./linkedinPixelCode";
import { outbrainPixelCode } from "./outbrainPixelCode";
import { permutiveScript, permutiveSphl } from "./permutive";
import { twitterPixelCode } from "./twitterPixelCode";
import { vwoPreconnect, vwoSmartcode } from "./vwoCode";

export default function HeadScriptProvider() {
  // DFP Preview
  useScriptFunction({
    id: "dfp-preview",
    value: dfpPreview,
  });

  // Edge Permutive App
  useScript({
    id: "edge-permutive-app",
    src: permutiveScript,
  });
  // Permutive SPHL
  useScriptFunction({
    id: "permutive-sphl",
    value: permutiveSphl,
  });

  // Facebook Event Tracking
  useScriptFunction({ id: "facebook-script", value: facebookEventScript });
  useScriptFunction({
    id: "facebook-no-script",
    value: facebookNoScript,
    noscript: true,
    portion: "body",
  });

  // Hotjar Tracking Code
  useScriptFunction({
    id: "hotjar-tracking-code",
    value: hotjarTrackingCode,
  });

  // VWO Smartcode
  useLink({
    id: "vwo-smartcode-preconnect",
    rel: "preconnect",
    href: vwoPreconnect,
  });
  useScriptFunction({
    id: "vwo-smartcode",
    value: vwoSmartcode,
  });

  // outbrain pixel
  useScriptFunction({
    id: "outbrain-pixel",
    value: outbrainPixelCode,
  });

  // linkedin pixel script
  useScriptFunction({
    id: "linkedin-pixel",
    value: linkedinPixelCode_script,
  });

  // linkedin pixel no script
  useScriptFunction({
    id: "linkedin-pixel-noscript",
    value: linkedinPixelCode_noScript,
    noscript: true,
  });

  // twitter pixed
  useScriptFunction({
    id: "twitter-pixel",
    value: twitterPixelCode,
  });

  return null;
}
